import { graphql } from "react-relay";

export const UpsertMSTeamsProfileMutation = graphql`
  mutation UpsertMSTeamsProfileMutation(
    $input: MSTeamsConfigurationInput!
    $connections: [ID!]!
  ) {
    upsertMSTeamsProfile(input: $input) {
      configuration
        @appendNode(
          connections: $connections
          edgeTypeName: "ConfigurationEdge"
        ) {
        profile
        record {
          ... on MSTeamsConfiguration {
            accessConfig {
              botApplication {
                downloadURL
                version
              }
              clientId
              publishedApplication {
                application {
                  catalogId
                  checkedAt
                  version
                }
                problems {
                  message
                }
              }
              roundtripDigest
              tenantId
            }
            channelMappings {
              channelId
              name
              teamId
            }
            customerConfig {
              prefix
              roundtripDigest
              tags {
                key
                value
              }
              terraformModule {
                source
                version
              }
            }
            entityDetails {
              channels {
                id
                name
              }
              teams {
                id
                name
              }
            }
          }
        }
        scope
      }
    }
  }
`;
